export default {
  admin: {
    tours: {
      default: false,
    },
    projects: {
      default: true,
    },
    groups: {
      default: false,
    },
    managers: {
      default: false,
    },
    payments: {
      default: false,
    },
    'custom-trips': {
      default: false,
    },
  },
  'tourism-operator': {
    species: {
      default: false,
      read: true,
    },
    'species-family': {
      default: false,
    },
    operators: {
      default: false,
    },
    'custom-trips': {
      default: false,
    },
  },

  tourist: {
    species: {
      default: false,
    },
    'species-family': {
      default: false,
    },
    managers: {
      default: false,
    },
    tours: {
      default: false,
    },
    projects: {
      default: false,
      read: true,
    },
  },
};
